/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* Renovo: highlighted word in headings.
 * In the theme editor, wrap a word in asterisks, e.g. Meet our *founder*
 * and it shows in HV Fitzgerald italic (styled in renovo-brand.css). */
(function () {
  function renovoItalics(root) {
    (root || document).querySelectorAll('.Heading, h1, h2, h3').forEach(function (el) {
      if (el.children.length) return;
      var text = el.textContent;
      if (!/\*[^*]+\*/.test(text)) return;
      var safe = text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
      el.innerHTML = safe.replace(/\*([^*]+)\*/g, '<em>$1</em>');
    });
  }
  renovoItalics();
  document.addEventListener('shopify:section:load', function (event) { renovoItalics(event.target); });
})();
